import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { estructuraFeeLogistico, updateFeeLogistico } from "../../../../api/axios.js"
import { toast } from '../../../../utilities/appToast';
import BigSpinner from "../../../General/BigSpinner";
import MiniSpinner from "../../../General/MiniSpinner";
import '../../shared/liquidacionesModule.css';
import LiquidacionesPageHeader from '../../shared/LiquidacionesPageHeader';
import { LiquidacionesBtnGuardar, LiquidacionesBtnCancelar } from '../../shared/LiquidacionesButtons';
import { LIQUIDACIONES_ROUTES } from '../../shared/liquidacionesRoutes';

const FeeNew = ({ idSeller, userType }) => {
  const navigate = useNavigate();
  const [logisticaPropia, setLogisticaPropia] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [vigenteDesde, setVigenteDesde] = useState(new Date().toISOString().split("T")[0]);
  const [vigenteHasta, setVigenteHasta] = useState(new Date().toISOString().split("T")[0]);


  const transformarCostosPorEscala = (costosFee) => {
    const resultado = [];
    costosFee.forEach((item) => {
      let escalaExistente = resultado.find((r) => r.escala === item.escala);
      if (!escalaExistente) {
        escalaExistente = { escala: item.escala, zonas: {} };
        resultado.push(escalaExistente);
      }
      escalaExistente.zonas[item.zona] = item.costo;
    });
    return resultado;
  };

  useEffect(() => {
    setIsFetchingData(true);

    estructuraFeeLogistico()
        .then((res) => {
            const costosTransformados = transformarCostosPorEscala(res?.costosfee);
        setLogisticaPropia(costosTransformados);
      })
      .catch((error) => {
        console.error("Error al obtener datos:", error);
      })
      .finally(() => {
        setIsFetchingData(false);
      });

  }, []);


  const zonasUnicas = [...new Set(logisticaPropia.flatMap(item => Object.keys(item.zonas)))];

  const handleChange = (e, escala, zona) => {
    const { value } = e.target;
    setLogisticaPropia((prevState) =>
      prevState.map((item) =>
        item.escala === escala ? { ...item, zonas: { ...item.zonas, [zona]: value } } : item
      )
    );
  };

  const handleFechaDesdeChange = (e) => {
    const nuevaFechaDesde = e.target.value;
    setVigenteDesde(nuevaFechaDesde);
    if (vigenteHasta && nuevaFechaDesde > vigenteHasta) {
      setVigenteHasta(nuevaFechaDesde);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let updatedZonas = [];

    logisticaPropia.forEach((escala) => {
      let escalasZonas = [];

      zonasUnicas.forEach((zona) => {
        const costo = escala.zonas[zona];

        if (costo !== undefined && !isNaN(parseFloat(costo)) && parseFloat(costo) > 0) {
          escalasZonas.push({
            zona,
            costo: parseFloat(costo)
          });
        }
      });

      if (escalasZonas.length > 0) {
        updatedZonas.push({
          escala: escala.escala,
          costos: escalasZonas
        });
      }
    });

    if (updatedZonas.length === 0) {
      toast.error("No hay datos válidos para actualizar.");
      return;
    }

    const request = {
      costosFee: updatedZonas.flatMap((escalaItem, escalaIndex) =>
        escalaItem.costos.map((costoItem, zonaIndex) => ({
          idZona: zonaIndex + 1,
          idEscala: escalaIndex + 1,
          costo: costoItem.costo
        }))
      ),
      vigenteDesde: new Date(vigenteDesde).toISOString(), // 🔹 Formatear fecha
      vigenteHasta: new Date(vigenteHasta).toISOString()  // 🔹 Formatear fecha
    };


    updateFeeLogistico(request)
      .then(() => {
        toast.success("Datos actualizados correctamente");
        navigate("/Liquidaciones/ActualizacionMasiva");
      })
      .catch(err => {
          const errores = err?.response?.data?.errores;
          if (Array.isArray(errores))
              errores.forEach(error => toast.error(error.item2));
          else
              toast.error("El Fee no pudo ser creado");
      });
  };



  const redirectToFee = () => {
    navigate("/Liquidaciones/ActualizacionMasiva");
  };

  return (

    <div className="container gestion-liquidaciones liquidaciones-modulo">
      <LiquidacionesPageHeader
        title="Crear nuevo fee"
        subtitle="Definí el fee logístico para el rango de fechas seleccionado."
        backTo={LIQUIDACIONES_ROUTES.actualizacionMasiva}
        backLabel="Volver"
        showBack
      />

      <div className="d-flex justify-content-start align-items-center gap-3 mt-3 mb-3">
        <div>
          <strong className="text-muted">Fecha desde</strong>
          <input
            type="date"
            className="form-control"
            value={vigenteDesde}
            min={new Date().toISOString().split("T")[0]} // 🔹 Restringe a la fecha actual o mayor
            onChange={handleFechaDesdeChange}
          />
        </div>
        <div>
          <strong className="text-muted">Fecha hasta</strong>
          <input
            type="date"
            className="form-control"
            value={vigenteHasta}
            min={vigenteDesde} // 🔹 Restringe `vigenteHasta` a `vigenteDesde` o mayor
            onChange={(e) => setVigenteHasta(e.target.value)}
          />
        </div>
      </div>



      {isFetchingData ? <BigSpinner message="Cargando estructura de fee..." /> : (
        <div className="row card align-items-center justify-content-center">
          <div className="animated fadeIn">
            <div className="table-responsive">
              <table className="table border-table">
                <thead>
                  <tr>
                    <th>Escala</th>
                    {zonasUnicas.map((zona, index) => (
                      <th key={index}>{zona} (Costo)</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {logisticaPropia.map((item, index) => (
                    <tr key={index} className="hover-background-color">
                      <td>{item.escala}</td>
                      {zonasUnicas.map((zona, idx) => (
                        <td key={idx}>
                          <small className="d-inline me-2">$</small>
                          <input
                            type="number"
                            name="costo"
                            value={item.zonas[zona] !== undefined ? item.zonas[zona] : ""}
                            min="0"
                            maxLength={8}
                            className="form-control d-inline text-center"
                            style={{ width: "100px" }}
                            onChange={(e) => handleChange(e, item.escala, zona)}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-flex justify-content-center my-3">
                <LiquidacionesBtnGuardar
                  onClick={onSubmit}
                  className="mx-2"
                  disabled={isUpdating}
                >
                  {isUpdating ? <MiniSpinner /> : "Crear fee"}
                </LiquidacionesBtnGuardar>
                <LiquidacionesBtnCancelar
                  onClick={redirectToFee}
                  className="mx-2"
                  disabled={isUpdating}
                >
                  Cancelar
                </LiquidacionesBtnCancelar>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  idSeller: state.sellers.currentSellerId,
  userType: state.general.userType,
});

export default connect(mapStateToProps)(FeeNew); 
